import { render, staticRenderFns } from "./teacherAuth.vue?vue&type=template&id=62ee6ce6&scoped=true&"
import script from "./teacherAuth.vue?vue&type=script&lang=js&"
export * from "./teacherAuth.vue?vue&type=script&lang=js&"
import style0 from "./teacherAuth.vue?vue&type=style&index=0&id=62ee6ce6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ee6ce6",
  null
  
)

export default component.exports